import { AxiosResponse } from 'axios'
import axios from '@/services/axios'
import type {
  StockTransactionCreatePayload,
  StockTransactionInterface,
  StockTransactionTypeInterface,
  StockTransactionUpdatePayload,
  StockOverviewItemInterface,
} from '@/models/shop/StockTransaction.types'

const SHOP_BASE_URI = process.env.VUE_APP_SHOP_V2_BASE_URI
const ENTITY = 'stock-transactions'

export default abstract class StockTransactionsApi {
  public static async getUserStockTransactionTypes(): Promise<
    AxiosResponse<{
      data: StockTransactionTypeInterface[]
      metadata: { count: number; page: number; size: number; sort: string }
    }>
  > {
    return await axios.get(`${SHOP_BASE_URI}/${ENTITY}/types`)
  }

  public static async getArenaStockTransactions(
    arenaId: string,
    params: object,
  ): Promise<
    AxiosResponse<{
      data: StockTransactionInterface[]
      metadata: { count: number; page: number; size: number; sort: string }
    }>
  > {
    const url = `${SHOP_BASE_URI}/arenas/${arenaId}/${ENTITY}`
    return await axios.get(url, { params })
  }

  public static async createStockTransaction(
    arenaId: string,
    data: StockTransactionCreatePayload,
  ): Promise<AxiosResponse<StockTransactionInterface>> {
    const url = `${SHOP_BASE_URI}/arenas/${arenaId}/${ENTITY}`
    return await axios.post(url, data)
  }

  public static async updateStockTransaction(
    arenaId: string,
    id: string,
    data: StockTransactionUpdatePayload,
  ): Promise<AxiosResponse<StockTransactionInterface>> {
    const url = `${SHOP_BASE_URI}/arenas/${arenaId}/${ENTITY}/${id}`
    return await axios.patch(url, data)
  }

  public static async getStockOverview(
    arenaId: string,
    params?: {
      date_gte?: string
      date_lt?: string
      day_type?: 'business' | 'calendar'
    },
  ): Promise<AxiosResponse<StockOverviewItemInterface[]>> {
    const url = `${SHOP_BASE_URI}/arenas/${arenaId}/${ENTITY}/overview`
    return await axios.get(url, { params })
  }
}
